import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class IssueFilterModel {
    public accountId: number;
    public siteId: number;
    public statusId: number;
    public contactId: number;
    public issueType1Id: number;
    public issueType2Id: number;
    public issueType3Id: number;
    public searchText: string;
    public fromDate: NgbDateStruct;
    public toDate: NgbDateStruct;
}



// WEBPACK FOOTER //
// ./src/app/models/IssueFilter.ts